import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GenericFormPageComponent } from './generic-form-page/generic-form-page.component';
import { AuswertungComponent } from './auswertung/auswertung.component'
import { UebersichtComponent } from './auswertung/uebersicht/uebersicht.component';
import { KrankheitComponent } from './auswertung/krankheit/krankheit.component';
import { UnfallComponent } from './auswertung/unfall/unfall.component';
import { EmBuComponent } from './auswertung/em-bu/em-bu.component';
import { PflegeComponent } from './auswertung/pflege/pflege.component';
import { AlterComponent } from './auswertung/alter/alter.component';
import { TestComponent } from './test/test.component'
import { CustomerOverviewComponent } from './customer-overview/customer-overview.component';
import { CustomerEditComponent } from './customer-overview//customer-edit/customer-edit.component';

const routes: Routes = [
  {
    pathMatch: 'full',
    path: '',
    redirectTo: 'eingaben/daten',
  },
  {
    path: 'eingaben',
    redirectTo: 'eingaben/daten',
  },
  {
    path: 'eingaben/daten',
    component: GenericFormPageComponent,
    data: {
      'pageNr': 1,
      'nextUrl': 'eingaben/finanzen',
      'token': 'eins',
    }
  },
  {
    path: 'eingaben/finanzen',
    component: GenericFormPageComponent,
    data: {
      'pageNr': 2,
      'nextUrl': 'eingaben/versorgung',
      'token': 'zwei',
    }
  },
  {
    path: 'eingaben/versorgung',
    component: GenericFormPageComponent,
    data: {
      'pageNr': 3,
      'isLastUrl': true,
      //'nextUrl': 'eingaben/weiteres',
      'token': 'drei',
    }
  },
  /*
  {
    path: 'eingaben/weiteres',
    component: GenericFormPageComponent,
    data: {
      'pageNr': 4,
      'isLastUrl': true,
      'token': 'vier',
    }
  },
  */
  {
    path: 'auswertung',
    redirectTo: 'auswertung/uebersicht',
  },
  {
    path: 'auswertung/uebersicht',
    component: UebersichtComponent,
  },
  {
    path: 'auswertung/krankheit',
    component: KrankheitComponent
  },
  {
    path: 'auswertung/unfall',
    component: UnfallComponent
  },
  {
    path: 'auswertung/em_bu',
    component: EmBuComponent
  },
  {
    path: 'auswertung/alter',
    component: AlterComponent
  },
  {
    path: 'auswertung/pflege',
    component: PflegeComponent
  },
  {
    path: 'test',
    component: TestComponent
  },
  {
    path: 'kundenuebersicht',
    component: CustomerOverviewComponent
  },
  {
    path: 'kundenbearbeitung',
    component: CustomerEditComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts